import { render, staticRenderFns } from "./PaymentScreenAch.vue?vue&type=template&id=2cfa43ec&scoped=true&"
import script from "./PaymentScreenAch.vue?vue&type=script&lang=js&"
export * from "./PaymentScreenAch.vue?vue&type=script&lang=js&"
import style0 from "./PaymentScreenAch.vue?vue&type=style&index=0&id=2cfa43ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa43ec",
  null
  
)

export default component.exports